/* eslint-disable jsx-a11y/anchor-is-valid */
import { Link } from "react-router-dom";
import JKACopyright from "../assets/images/JKA-Copyright.png";
import JKAWAUP from "../assets/images/JKA-WA-UP.png";
import JKAWeChatUP from "../assets/images/JKA-WeChat-UP.png";
import JKApayments from "../assets/images/JKA-payments.png";
import WorkingProcess1 from "./WorkingProcess1";
import jklogolong from "../assets/images/jk logo-long.png";
import EmailForm from "./EmailForm";

function Footer() {
  return (
    <>
      <WorkingProcess1 />
      <div className="container-fluid bg-light footer pt-0">
        <div className="container">
          <div className="row g-3">
            <EmailForm />

            <div className="text-center">
              <p className="heading">We Accept EMI</p>
            </div>

            <div className="col-lg-12">
              <div className="text-center">
                <img
                  className="mx-auto responsive-img"
                  src={JKApayments}
                  alt="JKA-payments"
                />
              </div>
            </div>

            <div className="col-lg-4 ">
              <div className="text-center">
                <img
                  className="mx-auto responsive-img"
                  src={JKAWAUP}
                  alt="JK Associates Whatsapp"
                />
              </div>
            </div>

            <div className="col-lg-4 ">
              <div className="text-center">
                <img
                  className="mx-auto responsive-img"
                  src={JKACopyright}
                  alt="JK Associates copyright"
                />
              </div>
            </div>

            <div className="col-lg-4 ">
              <div className="text-center">
                <img
                  className="mx-auto responsive-img"
                  src={JKAWeChatUP}
                  alt="JK Associates wechat"
                />
              </div>
            </div>

            {/* ABOUT US */}
            <div style={{ marginTop: "30px" }} className="col-lg-4 col-md-6">
              <h5 className="mb-4">ABOUT US</h5>
              <img
                src={jklogolong}
                alt="send"
                style={{ width: "60%", height: "40px" }}
              />
              <p style={{ textAlign: "justify" }}>
                JK Associates is the most prominent Corporate Consultancy and
                Law firm in Bangladesh. We provide specialized services in
                Business Setup (Local and Foreign company), Intellectual
                Property Rights (Trademark, Copyright), Corporate Affairs,
                Foreign Direct Investment (FDI) and Taxation (Tax, VAT).
                <br />
                <Link className="mb-0 btn btn-link" to="/about-us">
                  Know more...
                </Link>
              </p>
            </div>

            {/* LET’S GROW */}
            <div style={{ marginTop: "30px" }} className="col-lg-2 col-md-6">
              <h5 className="mb-2">LET’S GROW!</h5>
              <Link to="/about-us">
                <p className="mb-0 btn btn-link">About Us</p>
              </Link>
              <Link to="/contact-us">
                <p className="mb-0 btn btn-link">Contact Us</p>
              </Link>
              <Link to="/privacy-policy">
                <p className="mb-0 btn btn-link">Privacy Policy</p>
              </Link>
              <Link to="/term-condition">
                <p className="mb-0 btn btn-link">Terms and Conditions</p>
              </Link>
              <Link to="/sitemap">
                <p className="mb-0 btn btn-link">Sitemap</p>
              </Link>
              <Link to="/payment-process">
                <p className="mb-0 btn btn-link">Payment Process</p>
              </Link>
              <Link to="/refund-policy">
                <p className="mb-0 btn btn-link">Refund & Return Policy</p>
              </Link>
            </div>

            {/* UPDATED MORE SERVICES */}
            <div style={{ marginTop: "30px" }} className="col-lg-2 col-md-6">
              <h5 className="mb-2">MORE SERVICES</h5>

              <Link to="/foreign-company-registration-in-bangladesh">
                <p className="mb-0 btn btn-link">Foreign Company</p>
              </Link>

              <Link to="/company-formation-in-bangladesh">
                <p className="mb-0 btn btn-link">Business Setup</p>
              </Link>

              <Link to="/startup-packages">
                <p className="mb-0 btn btn-link">Startup Package</p>
              </Link>

              <Link to="/trademark-registration-in-bangladesh">
                <p className="mb-0 btn btn-link">Trademark Registration</p>
              </Link>

              <Link to="/copyright-registration">
                <p className="mb-0 btn btn-link">Copyright Services</p>
              </Link>

              <Link to="/corporate-tax">
                <p className="mb-0 btn btn-link">Corporate Tax</p>
              </Link>

              <Link to="/bookkeeping-services">
                <p className="mb-0 btn btn-link">Bookkeeping Services</p>
              </Link>
            </div>

            {/* NEW TRAINING SECTION */}
            <div style={{ marginTop: "30px" }} className="col-lg-2 col-md-6">
              <h5 className="mb-2">TRAINING</h5>

              <Link to="/training">
                <p className="mb-0 btn btn-link">Training</p>
              </Link>

              <Link to="/training-about-us">
                <p className="mb-0 btn btn-link">About Us</p>
              </Link>

              <Link to="/professional-business-courses">
                <p className="mb-0 btn btn-link">Business Courses</p>
              </Link>

              <Link to="/Accounting-Course">
                <p className="mb-0 btn btn-link">Accounting Training</p>
              </Link>

              <Link to="/professional-taxation-training">
                <p className="mb-0 btn btn-link">Taxation Training</p>
              </Link>

              <Link to="/professional-management-training">
                <p className="mb-0 btn btn-link">Management Training</p>
              </Link>
            </div>

            {/* EXISTING EXTRA LINKS */}
            <div className="col-lg-2 col-md-6" style={{ marginTop: "40px" }}>
              <Link to="https://trademarkbd.com/blog/">
                <p className="mb-0 btn btn-link">Trademark Search</p>
              </Link>
              <Link to="/co-space">
                <p className="mb-0 btn btn-link">JK Cospace</p>
              </Link>
              <Link to="/vat-calculator">
                <p className="mb-0 btn btn-link">VAT Calculator</p>
              </Link>
              <Link to="/visa-consultancy">
                <p className="mb-0 btn btn-link">VISA Consultancy</p>
              </Link>
              <Link to="/property-consultancy">
                <p className="mb-0 btn btn-link">Property Consultancy</p>
              </Link>
              <Link to="/resource">
                <p className="mb-0 btn btn-link">Resources</p>
              </Link>
              <Link to="/blog">
                <p className="mb-0 btn btn-link">Blogs</p>
              </Link>
            </div>
          </div>
        </div>

        {/* COPYRIGHT SECTION */}
        <div className="container-fluid copyright">
          <div className="container">
            <div className="row">
              <div className="col-md-6 text-center d-flex align-items-center justify-content-center mb-3 mb-md-0">
                Copyright © {new Date().getFullYear()} Corporate legal
                consultancy firms in Bangladesh{" "}
                <Link
                  style={{ paddingLeft: "2px" }}
                  target="_blank"
                  to="https://jkassociates.com.bd/"
                >
                  JK Associates
                </Link>
              </div>
              <div className="col-md-6 text-center d-flex align-items-center justify-content-center mb-3 mb-md-0">
                <div className="d-flex" style={{ gap: "20px" }}>
                  <Link
                    className="btn btn-square rounded-circle me-1"
                    target="_blank"
                    to="#"
                    aria-label="button for goes to the top of page"
                  >
                    <i className="fab fa-twitter" />
                  </Link>
                  <Link
                    className="btn btn-square rounded-circle me-1"
                    target="_blank"
                    to="https://www.facebook.com/jkassociates.com.bd"
                    aria-label="button for our official facebook page"
                  >
                    <i className="fab fa-facebook-f" />
                  </Link>
                  <Link
                    to="https://www.youtube.com/@jkassociates7093"
                    className="btn btn-square rounded-circle me-1"
                    target="_blank"
                    aria-label="button for our official youtube channel"
                  >
                    <i className="fab fa-youtube" />
                  </Link>
                  <Link
                    className="btn btn-square rounded-circle me-1"
                    target="_blank"
                    to="https://www.linkedin.com/company/31521176/admin/feed/posts/"
                    aria-label="button for our official linkedIn profile"
                  >
                    <i className="fab fa-linkedin-in" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* BACK TO TOP BUTTON */}
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        className="btn btn-lg btn-primary btn-lg-square rounded-circle back-to-top"
        style={{ position: "fixed", bottom: "18px", left: "20px" }}
        title="Back to Top"
      >
        <i className="bi bi-arrow-up"></i>
      </button>
    </>
  );
}

export default Footer;
